const BASE_ICON_URL = 'https://49725625.fs1.hubspotusercontent-na1.net/hubfs/49725625/app-icons/';
const AppDefinition = {
  gdrive: {
    displayName: 'Google Drive',
    iconUrl: `${BASE_ICON_URL}gdrive.svg`
  },
  gmail: {
    displayName: 'Gmail',
    iconUrl: `${BASE_ICON_URL}gmail.svg`
  },
  gcal: {
    displayName: 'Google Calendar',
    iconUrl: `${BASE_ICON_URL}gcal.svg`
  },
  slack: {
    displayName: 'Slack',
    iconUrl: `${BASE_ICON_URL}slack.svg`
  },
  msteams: {
    displayName: 'Microsoft Teams',
    iconUrl: `${BASE_ICON_URL}msteams.svg`
  },
  outlook: {
    displayName: 'Outlook',
    iconUrl: `${BASE_ICON_URL}outlook.svg`
  },
  onedrive: {
    displayName: 'OneDrive',
    iconUrl: `${BASE_ICON_URL}onedrive.svg`
  },
  sharepoint: {
    displayName: 'SharePoint',
    iconUrl: `${BASE_ICON_URL}sharepoint.svg`
  },
  confluence: {
    displayName: 'Confluence',
    iconUrl: `${BASE_ICON_URL}confluence.svg`
  },
  jira: {
    displayName: 'Jira',
    iconUrl: `${BASE_ICON_URL}jira.svg`
  },
  azure_devops: {
    displayName: 'Azure DevOps',
    iconUrl: `${BASE_ICON_URL}azure_devops.svg`
  }
};
export const getAppInfo = appName => {
  return AppDefinition[appName] || {
    displayName: appName,
    iconUrl: `${BASE_ICON_URL}app.svg`
  };
};
export const getAppDisplayName = appName => {
  return getAppInfo(appName).displayName;
};